import { colors, fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const background = '#F4F6F6';
const dustyGray = '#959595';
const { text } = theme;

export const resultsPane = css`
  z-index: 10;
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  max-height: ${pxToRem(300)};
  overflow-y: scroll;
  background: ${colors.neutralWhite};
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(3)} 0 ${colors.neutralLight};
  width: 100%;
  max-width: 40rem;

  &:empty {
    height: 0;
  }
`;

export const result = css`
  font-size: ${pxToRem(13)};
  padding: ${pxToRem(8)} ${pxToRem(10)};
  position: relative;
  border-top: ${pxToRem(1)} solid ${background};
  border-bottom: ${pxToRem(1)} solid ${background};

  &[data-is-result='true'] {
    cursor: pointer;
  }

  &[data-is-result-highlighted='true'] {
    background-color: ${background};
  }

  &[data-is-result-container='true'] :before {
    content: '';
    display: block;
    position: absolute;
    box-sizing: content-box;
    top: 50%;
    right: ${pxToRem(13.5)};
    z-index: 1;
    border-left: ${pxToRem(2)} solid ${colors.neutralDark};
    border-bottom: ${pxToRem(2)} solid ${colors.neutralDark};
    transform: translateY(-50%) rotate(-135deg);
    width: ${pxToRem(8)};
    height: ${pxToRem(8)};
    pointer-events: none;
  }

  > * {
    margin: 0;
  }
`;

export const resultTitle = css`
  color: ${colors.neutralDark};
`;

export const resultSubtitle = css`
  color: ${dustyGray};
  margin-right: ${pxToRem(20)};
`;

export const hint = css`
  color: ${colors.neutralDark};
  font-style: italic;
`;

export const fakeLink = css`
  color: ${colors.brandBluePrimary};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const input = css`
  ${fontSize(text.BODY.MD)};
  border: solid ${pxToRem(1)} ${colors.neutralLight};
  border-radius: ${pxToRem(10)};
  color: ${colors.neutralDarker};
  display: block;
  overflow: hidden;
  padding: ${pxToRem(9)} ${pxToRem(16)};
  margin: ${pxToRem(9)} 0;
  resize: none;
  transition: border-color 0.15s ease-in, background-color 0.15s ease-in;
  width: 100%;
  appearance: none;
  max-width: 40rem;
`;
